import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface UIState {
    theme: 'light' | 'dark' | 'system';
    largeType: boolean;
}

const initialState: UIState = {
    theme: 'system',
    largeType: false,
};

export const uiSlice = createSlice({
    name: 'ui',
    initialState,
    reducers: {
        setTheme: (state, action: PayloadAction<UIState['theme']>) => {
            state.theme = action.payload;
        },
        setLargeType: (state, action: PayloadAction<boolean>) => {
            state.largeType = action.payload;
        },
    },
    selectors: {
        selectTheme: (uiState: UIState) => uiState.theme,
        selectLargeType: (uiState: UIState) => uiState.largeType,
    },
});

export const { setTheme, setLargeType } = uiSlice.actions;

export const { selectTheme, selectLargeType } = uiSlice.selectors;

export default uiSlice.reducer;
